
















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storePenunjang } from "@/store/modules/penunjang";
import DetailPenunjangLain from "@/components/pemeriksaan/penunjang/DetailPenunjangLain.vue";
import PdfPenunjang from "@/components/pemeriksaan/penunjang/Pdf.vue";
import moment from "moment";
import ZoomModal from "@/components/pemeriksaan/penunjang/ZoomModal.vue";

@Component({
  components: {
    DetailPenunjangLain,
    PdfPenunjang,
    ZoomModal
  }
})
export default class CardRiwayatPenunjangLain extends Vue {
  @Prop() type!: string;
  @Prop() rm!: string;
  @Prop() panelriwayat!: Array<object>;
  @Prop() showdetail!: boolean;

  tab = "buat-order";
  modalBatalOrder = false;
  idOrder = "";
  selectedDetail = null;
  showEdit = false;
  // showdetail = false;
  dtpenunjanglain = {};
  showFile = false;
  zoom = false;
  dtfile;
  activeId = "";

  mounted() {}

  get stateuser() {
    return userModule.user;
  }

  get itemsInReg() {
    return storePenunjang.riwayatpenunjanglain;
  }

  @Watch("showdetail")
  changedShowdetail(val) {
    if (!val) {
      this.showFile = false;
      this.dtpenunjanglain = {};
      this.activeId = "";
    }
  }

  showImageDivider(index, files) {
    return files.length > 0 && index < files.length - 1;
  }

  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }
  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm") : "";
  }

  showItem(item) {
    this.dtpenunjanglain = item;
    this.activeId = item.id;
    this.showFile = true;
  }

  openDialog(v) {
    this.zoom = true;
    this.dtfile = v;
  }

  pdfZoom(v) {
    this.zoom = true;
    this.dtfile = v;
  }

  uniqueCategory(categories) {
    return categories
      .map(item => item.penunjang_lain_kategori.nama)
      .sort((a, b) => {
        if (a < b) {
          return 1;
        }
        if (a > b) {
          return -1;
        }
        return 0;
      })
      .filter((value, index, array) => {
        return array.indexOf(value) === index;
      })
      .join(", ");
  }

  renderDate(register) {
    if (!register.date_out || register.date_in === register.date_out) {
      return register.date_in;
    } else {
      return `${register.date_in} s/d ${register.date_out} `;
    }
  }

  cetak(v) {
    window.open(v, "_blank");
  }
}
